$(document).ready(function() {
        $('.site-footer__linklist li:nth-child(3)').addClass("faqchild");
    });

$(document).ready(function() {
$("ul li.site-footer__linklist-item.faqchild a").on("click",function(){
    $(this).find("ul.child.custom").toggle();
    $("ul.child.custom").toggle();

 });
});

/*$(document).ready(function() {
$(".site-footer__linklist li" ).last().addClass("faqchild");

});*/

